import PropTypes from 'prop-types';
// @mui
import {  Stack } from '@mui/material';
// components
import Logo from '../../components/logo';
// import Image from '../../components/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';

// ----------------------------------------------------------------------

LoginLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  illustration: PropTypes.string,
};

export default function LoginLayout({ children, illustration, title }) {
  return (
    <StyledRoot>
      {/* <Logo
        sx={{
          zIndex: 9,
          position: 'absolute',
          mt: { xs: 1.5, md: 5 },
          ml: { xs: 2, md: 5 },
        }}
      /> */}

      <StyledSection>
        {/* <Typography variant="h3" sx={{ mb: 10, maxWidth: 480, textAlign: 'center' }}>
          {title}
        </Typography> */}

        {/* <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          ratio="1/1"
          // src={illustration || '/logo/logo_full.png'}
          src={illustration || '/logo/logo_full.png'}
          sx={{ maxWidth: 720, objectFit: 'contain' }}
        /> */}

        <Logo 
          sx={{ height: 400, width: 600 }}
        />
     

        <StyledSectionBg />
      </StyledSection>

      <StyledContent>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
}
